import { FC } from 'react';
import { MemberAvatar } from '../household/MemberAvatar';
import { buildDisplayName } from '../avatar/avatarInitials';

export type ICommunityAvatar = {
    pictureUrl?: string;
    firstName?: string;
    lastName?: string;
    size?: number;
};

// Delegates to the shared avatar so a community post renders a photo, initials, a failed-image
// placeholder and a loading state identically to every other surface.
export const CommunityAvatar: FC<ICommunityAvatar> = ({ pictureUrl, firstName, lastName, size = 48 }) => (
    <MemberAvatar
        size={size}
        member={{ photo: pictureUrl }}
        name={buildDisplayName({ firstName, lastName })}
        noImageFallback="initials"
    />
);
